import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
    theme: {
        primary: "#3F51B5",
        secondary: "#7986CB",
        accent: "#5C6BC0",
        error: "#f44336",
        warning: "#448AFF",
        info: "#64B5F6",
        success: "#4caf50"
    }
})
